import { graphql } from '@/gql';
import type { PartnerGeofencesQuery, PartnerGeofenceTarget } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export { PartnerGeofenceTarget } from '@/gql/graphql';

export type PartnerGeofence = NonNullable<PartnerGeofencesQuery['partnerGeofences']>[0];

export const fetchPartnerGeofences = async (partnerCodeName: string, target?: PartnerGeofenceTarget): Promise<PartnerGeofence[]> => {
  const response = await queryExecute({
    query: graphql(`
      query PartnerGeofences($partnerCodeName: String!, $target: PartnerGeofenceTarget) {
        partnerGeofences(partnerCodeName: $partnerCodeName, target: $target) {
          id
          partnerId
          code
          data
          target
          centroid {
            lat
            lng
          }
          polygons {
            lat
            lng
          }
        }
      }
    `),
    variables: {
      partnerCodeName,
      target,
    },
    fetchPolicy: 'cache-first',
  });

  return response.data.partnerGeofences || [];
};
